// extracted by mini-css-extract-plugin
module.exports = {"stack":"DoctorAvatarStack-module__stack___oACY9","avatar":"DoctorAvatarStack-module__avatar___1TLAl"};